import ZariDivider from "../components/ZariDivider";

function PrivacyPolicy() {
    return (
        <>
            <title>Privacy Policy | Fashion Freude</title>
            <meta name="title" content="Privacy Policy | Fashion Freude" />
            <meta
                name="description"
                content="Read the official Privacy Policy for Fashion Freude. Learn how we collect, use, store, and protect your personal data, cookies, and account details."
            />
            <meta
                name="keywords"
                content="Fashion Freude privacy policy, data protection, user privacy, cookies policy, Fashion Freude terms"
            />
            <meta name="robots" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="canonical" href="https://fashionfreude.com/privacy-policy" />

            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://fashionfreude.com/privacy-policy" />
            <meta property="og:title" content="Privacy Policy | Fashion Freude" />
            <meta
                property="og:description"
                content="Learn how Fashion Freude protects your privacy, manages user data, and ensures safe shopping across our website."
            />
            <meta property="og:image" content="https://fashionfreude.com/logo.png" />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:url" content="https://fashionfreude.com/privacy-policy" />
            <meta name="twitter:title" content="Privacy Policy | Fashion Freude" />
            <meta
                name="twitter:description"
                content="Learn how Fashion Freude protects your privacy, manages user data, and ensures safe shopping across our website."
            />
            <meta name="twitter:image" content="https://fashionfreude.com/logo.png" />

            <div className="bg-ivory">
                <section className="bg-cream">
                    <div className="container-luxe py-16 text-center">
                        <p className="eyebrow">Your Privacy Matters</p>

                        <h1 className="mt-3 font-display text-4xl leading-tight text-ink sm:text-5xl">
                            Privacy Policy
                        </h1>

                        <ZariDivider className="mt-5" />

                        <p className="mx-auto mt-5 max-w-2xl text-muted leading-relaxed">
                            Your privacy is important to us. This Privacy Policy explains how
                            Fashion Freude collects, uses, and protects your personal information
                            while using our website.
                        </p>
                    </div>
                </section>

                <div className="container-luxe py-14">
                    <div className="mx-auto max-w-3xl space-y-6">
                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">1. Who we are</h2>

                            <p className="mt-3 text-muted leading-relaxed">
                                Our website address is: https://fashionfreude.com.
                            </p>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">2. Comments</h2>

                            <p className="mt-3 text-muted leading-relaxed">
                                When visitors leave comments on the site we collect the data shown in
                                the comments form, and also the visitor’s IP address and browser user
                                agent string to help spam detection.
                            </p>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">3. Media</h2>

                            <p className="mt-3 text-muted leading-relaxed">
                                If you upload images to the website, you should avoid uploading images
                                with embedded location data (EXIF GPS) included. Visitors to the website
                                can download and extract any location data from images on the website.
                            </p>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">4. Cookies</h2>

                            <div className="mt-3 space-y-4 text-muted leading-relaxed">
                                <p>
                                    If you leave a comment on our site you may opt-in to saving your name,
                                    email address and website in cookies. These are for your convenience so
                                    that you do not have to fill in your details again when you leave
                                    another comment. These cookies will last for one year.
                                </p>

                                <p>
                                    If you visit our login page, we will set a temporary cookie to determine
                                    if your browser accepts cookies. This cookie contains no personal data
                                    and is discarded when you close your browser.
                                </p>

                                <p>
                                    When you log in, we will also set up several cookies to save your login
                                    information and your screen display choices. Login cookies last for two
                                    days, and screen options cookies last for a year. If you select
                                    “Remember Me”, your login will persist for two weeks. If you log out of
                                    your account, the login cookies will be removed.
                                </p>

                                <p>
                                    If you edit or publish an article, an additional cookie will be saved in
                                    your browser. This cookie includes no personal data and simply indicates
                                    the post ID of the article you just edited. It expires after 1 day.
                                </p>
                            </div>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">
                                5. Embedded content from other websites
                            </h2>

                            <div className="mt-3 space-y-4 text-muted leading-relaxed">
                                <p>
                                    Articles on this site may include embedded content (e.g. videos, images,
                                    articles, etc.). Embedded content from other websites behaves in the
                                    exact same way as if the visitor has visited the other website.
                                </p>

                                <p>
                                    These websites may collect data about you, use cookies, embed additional
                                    third-party tracking, and monitor your interaction with that embedded
                                    content, including tracking your interaction with the embedded content
                                    if you have an account and are logged in to that website.
                                </p>
                            </div>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">
                                6. Who we share your data with
                            </h2>

                            <p className="mt-3 text-muted leading-relaxed">
                                If you request a password reset, your IP address will be included in the
                                reset email.
                            </p>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">
                                7. How long we retain your data
                            </h2>

                            <div className="mt-3 space-y-4 text-muted leading-relaxed">
                                <p>
                                    If you leave a comment, the comment and its metadata are retained
                                    indefinitely. This is so we can recognize and approve any follow-up
                                    comments automatically instead of holding them in a moderation queue.
                                </p>

                                <p>
                                    For users that register on our website (if any), we also store the
                                    personal information they provide in their user profile. All users can
                                    see, edit, or delete their personal information at any time (except they
                                    cannot change their username). Website administrators can also see and
                                    edit that information.
                                </p>
                            </div>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">
                                8. What rights you have over your data
                            </h2>

                            <p className="mt-3 text-muted leading-relaxed">
                                If you have an account on this site, or have left comments, you can
                                request to receive an exported file of the personal data we hold about
                                you, including any data you have provided to us. You can also request
                                that we erase any personal data we hold about you. This does not include
                                any data we are obliged to keep for administrative, legal, or security
                                purposes.
                            </p>
                        </div>

                        <div className="card p-7">
                            <h2 className="font-display text-2xl text-ink">
                                9. Where your data is sent
                            </h2>

                            <p className="mt-3 text-muted leading-relaxed">
                                Visitor comments may be checked through an automated spam detection
                                service.
                            </p>

                            <div className="mt-5 space-y-2 border-t border-sand pt-5 text-muted">
                                <p>📧 fashionfreude@gmail.com</p>

                                <p>📞 +91 00000 00000</p>

                                <p>📍 Fashion Freude, India</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PrivacyPolicy;
